<template>
  <div>
    <Bio :extra="extra" :lite="true" :can-access-contact-informations="canAccessContactInformations" :display-overlay="false" />

    <Contact v-if="displayContactButtons" class="margin-10-0" :phone="extra.getIdentity().phone" :email="extra.getIdentity().email" />

    <QBtn
      v-if="cancelShiftsAllowed"
      class="full-width"
      outline
      :label="$t('ETAB.PAGES.EXTRA.@CANCEL_FUTURE_SHIFTS')"
      icon="close"
      color="negative"
      @click="onCancelShifts"
    />

    <Shifts :extra="extra" @open-recruitment-recap="openRecruitmentRecap" />
  </div>
</template>

<script>
  import { EventManager } from "@core/managers/event.manager";
  import Bio from "@etab/components/extra/Bio.component.vue";
  import Shifts from "@etab/components/extra/Shifts.component.vue";
  import Contact from "@etab/components/common/Contact.component.vue";
  import { ETAB_EVENTS } from "@etab/config";
  import { ExtraModel } from "@core/models";

  export default {
    components: {
      Bio,
      Contact,
      Shifts,
    },
    props: {
      extra: {
        type: Object,
        default: () => new ExtraModel(),
      },
      canAccessContactInformations: {
        type: Boolean,
        default: false,
      },
      displayContactButtons: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      cancelShiftsAllowed() {
        // RG: can cancel as long as the first shift didn't start and extra didn't cancel already
        return !this.extra.hasFirstShiftStarted() && !this.extra.isCanceled() && !this.extra.isIgnored();
      },
    },
    methods: {
      onCancelShifts() {
        EventManager.emit(ETAB_EVENTS.EXTRA.CANCEL_SHIFTS, { extra: this.extra });
      },
      openRecruitmentRecap() {
        EventManager.emit(ETAB_EVENTS.RECRUITMENT.OPEN_RECRUITMENT_RECAP);
      },
    },
  };
</script>
